import { lenis } from "./lenis.js";

const init = () => {

    // --- Hamburger / mobile menu ---
    const hamburger = document.querySelector('.header-hamburger');
    const headerNav = document.querySelector('.header-nav');
    const body = document.body;

    if (hamburger && headerNav) {

        const outsideClickListener = (e) => {
            // If click target is NOT in headerNav AND NOT in hamburger, close the menu
            if (!headerNav.contains(e.target) && !hamburger.contains(e.target)) {
                closeMenu();
            }
        };

        const closeMenu = () => {
            hamburger.classList.remove('is-active');
            hamburger.setAttribute('aria-expanded', 'false');
            headerNav.classList.remove('is-active');
            body.classList.remove('menu-open');
            document.removeEventListener('click', outsideClickListener);
            if (lenis) lenis.start();
        };

        hamburger.addEventListener('click', (e) => {
             // Toggle active states
             const isActive = hamburger.classList.toggle('is-active');
             hamburger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
             headerNav.classList.toggle('is-active');
             body.classList.toggle('menu-open');
             
             if (isActive) {
                 // Menu opened, add listener to body/document
                 document.addEventListener('click', outsideClickListener);
                 if (lenis) lenis.stop();
             } else {
                 // Menu closed, remove listener
                 document.removeEventListener('click', outsideClickListener);
                 if (lenis) lenis.start();
             }
        });
        
        // Close menu when clicking links
        const links = headerNav.querySelectorAll('a');
        links.forEach(link => {
            link.addEventListener('click', () => {
                closeMenu();
            });
        });
    }
};

export { init };
